import React, { useState, useEffect, useCallback, useRef } from 'react';
import Lottie from 'lottie-react';
import './SplashScreen.css';

const EXIT_TRANSITION_MS = 400;
const MAX_SPLASH_MS = 3500;
const ANIMATION_URL = `${process.env.PUBLIC_URL || ''}/animation/Handshake Loop.json`;

const SplashScreen = ({ onComplete }) => {
  const [isExiting, setIsExiting] = useState(false);
  const [animationData, setAnimationData] = useState(null);
  const finishedRef = useRef(false);

  const finishSplash = useCallback(() => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    setIsExiting(true);
    setTimeout(() => {
      onComplete?.();
    }, EXIT_TRANSITION_MS);
  }, [onComplete]);

  useEffect(() => {
    let cancelled = false;

    fetch(encodeURI(ANIMATION_URL))
      .then((res) => {
        if (!res.ok) throw new Error('Animation fetch failed');
        return res.json();
      })
      .then((data) => {
        if (!cancelled) setAnimationData(data);
      })
      .catch(() => {
        if (!cancelled) setAnimationData(null);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // Always dismiss splash — Lottie onComplete can fail to fire on loop-style files
  useEffect(() => {
    const timer = setTimeout(finishSplash, MAX_SPLASH_MS);
    return () => clearTimeout(timer);
  }, [finishSplash]);

  return (
    <div className={`splash-screen ${isExiting ? 'splash-screen--exit' : ''}`}>
      <div className="splash-screen__inner">
        {animationData ? (
          <Lottie
            animationData={animationData}
            loop={false}
            onComplete={finishSplash}
            className="splash-screen__lottie"
          />
        ) : (
          <div className="splash-screen__loader" aria-hidden="true" />
        )}
        <p className="splash-screen__brand">GoToBusiness.live</p>
      </div>
    </div>
  );
};

export default SplashScreen;
